import axios from 'axios';

const config = {
	headers: {
		'x-access-token': sessionStorage.token,
	},
};

let host = 'http://localhost:8000/';
if (process.env.NODE_ENV === 'production') {
	host = 'https://reale-server.herokuapp.com/';
}
const url = `${host}api/auctions`;

const getAllAuctions = () => axios.get(url, config);

const getAuction = (id: string) => axios.get(`${url}/${id}`, config);

const addAuction = (obj: any) => axios.post(url, obj, config);

const updateAuction = (id: string, obj: any) =>
	axios.put(`${url  }/${  id}`, obj, config);

const deleteAuction = (id: string) => axios.delete(`${url  }/${  id}`, config);

// //ONLY FOR LANDING PAGE - OPEN TO ALL
// const getLandingJob = (id) => {
// 	return axios.get(url2 + '/' + id);
// };

export default {
	getAllAuctions,
	getAuction,
	addAuction,
	updateAuction,
	deleteAuction,
};
